import { createBrowserRouter, RouterProvider, type RouteObject } from "react-router";
import { StrictMode, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { routes } from "@core/router/routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useUiStore } from "@core/stores/uiStore";
import { useBreakpoint } from "@core/hooks/useBreakpoint";
import "@/app.css";
import { worker } from "@core/mock/browser";

// if (import.meta.env.DEV) {
if (import.meta.env.DEV && import.meta.env.API_NETWORK === "local") {
  worker.start({
    onUnhandledRequest: "bypass",
    quiet: true,
  });
}

// RWD에서 index.js?_={timestmap} 로 호출하여 브라우저에서 Main.js에서 참조하는 index.js 를 재호출함
// 브라우저에서 querystring 붙은 파일은 서로 다른 파일로 인지하여 재호출함
if (!window.__createRoot) {
  window.__createRoot = true;

  const root = document.getElementById("root") as HTMLElement;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  // queryClient 저장
  useUiStore.setState({ queryClient });

  const { network } = useUiStore.getState();
  const router = createBrowserRouter(routes(network) as RouteObject[]);

  const App = () => {
    const setBp = useUiStore((state) => state.setBp);
    const bp = useBreakpoint();

    // breakpoint 설정
    useEffect(() => {
      setBp(bp);
    }, [bp, setBp]);

    return (
      <>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </>
    );
  };

  ReactDOM.createRoot(root).render(
    <QueryClientProvider client={queryClient}>
      <StrictMode>
        <App />
      </StrictMode>
    </QueryClientProvider>,
  );
}
